var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { VBox } from "../structural_components/hbox_vbox";
import { Label, DescriptionLabel, ErrorLabel } from "./label";
import { createControlId } from "./id_creator";
import { bind } from "./control";
import { createEntityFieldGetter } from "../state/entity";
import { getFieldErrorsAsString } from "../validation/validatableentity";
import { cls_form_item_box } from "./form_item.css";
import { cls_textarea } from "./text_area.css";
var TextAreaBase = function (props) {
    var label = props.label, description = props.description, error = props.error, getter = props.getter, setter = props.setter, props_other = __rest(props, ["label", "description", "error", "getter", "setter"]);
    var id = createControlId();
    var binding = bind(props);
    var value = binding.value || '';
    var _a = React.useState(null), cursor = _a[0], setCursor = _a[1];
    var ref = React.useRef(null);
    React.useEffect(function () {
        var input = ref.current;
        if (input)
            input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);
    var handleChange = function (e) {
        setCursor(e.target.selectionStart);
        binding.onChange(e.target.value);
    };
    return React.createElement(VBox, { className: cls_form_item_box },
        React.createElement(Label, null, label),
        React.createElement("textarea", __assign({}, props_other, { id: id, ref: ref, value: value, onChange: function (e) { return handleChange(e); }, className: cls_textarea, disabled: props.disabled })),
        description ? React.createElement(DescriptionLabel, { htmlFor: id }, description) : React.createElement(React.Fragment, null),
        error ? React.createElement(ErrorLabel, null, error) : React.createElement(React.Fragment, null));
};
export var TextArea = function (props) {
    var _a, _b, _c;
    var getter = props.getter || createEntityFieldGetter(props.state);
    var setter = props.setter || ((_a = props.actions) === null || _a === void 0 ? void 0 : _a.setEntityField) || null;
    var error = (_c = (_b = props.error) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : (props.state && props.name ? getFieldErrorsAsString(props.state, props.name) : null);
    return React.createElement(TextAreaBase, __assign({}, props, { getter: getter, setter: setter, error: error }));
};
